// extracted by mini-css-extract-plugin
export default {"Main":"styles_Main__Rf0+U","searchWrapper":"styles_searchWrapper__HINUs","stherWorksWrapper":"styles_stherWorksWrapper__oN9nE","otherWorksWrapper":"styles_otherWorksWrapper__4saaa"};